export enum Size {
  SMALL = 'small',
  MEDIUM = 'medium',
  LARGE = 'large'
}

export enum Colors {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
  INFO = 'info',
  SUCCESS = 'success',
  WARNING = 'warning',
  ERROR = 'error',
  DARK = 'dark'
}

export const THEME_LABELS: { [key: string]: string } = {
  DEFAULT: 'Default',
  RIVER_NIGHTS: 'River Nights',
  SPRING_PASTELS: 'Spring Pastels',
  MARIGOLD: 'Marigold',
  MYSTIC_HUES: 'Mystic Hues'
};

export const THEME_STYLES: { [key: string]: string[] } = {
  DEFAULT: [
    '#4287f5',
    '#f0a34a',
    '#f86b9e',
    '#e64e36',
    '#f4c25c',
    '#c3d84a',
    '#8bc959',
    '#a73ed2',
    '#5e8b3d',
    '#f4a744',
    '#e258f5',
    '#5697a3',
    '#f97373',
    '#68a53a',
    '#d154b5',
    '#3e2d71',
    '#ff9a87',
    '#cc5a3e',
    '#6d6b91'
  ],
  RIVER_NIGHTS: [
    '#5C94F9',
    '#46B276',
    '#FD8767',
    '#A37CE7',
    '#88EEF4',
    '#5F43AF',
    '#E87C91',
    '#81E77C',
    '#E3798D',
    '#7CB5E7',
    '#E7CD7C',
    '#9d5c90',
    '#39b9b5',
    '#d95755',
    '#8b6cc3',
    '#56c59c',
    '#e2c138',
    '#84a33d',
    '#ef6b4a',
    '#5d9491',
    '#ca99d4'
  ],
  SPRING_PASTELS: [
    '#fd7f6f',
    '#7eb0d5',
    '#b2e061',
    '#bd7ebe',
    '#ffb55a',
    '#ffee65',
    '#beb9db',
    '#fdcce5',
    '#8bd3c7',
    '#f7889b',
    '#6f94bc',
    '#dd9d71',
    '#a493e1',
    '#f8bf53',
    '#d2eb80',
    '#eab6d1',
    '#88b1b4',
    '#f9a9a5',
    '#6aebbc',
    '#e6aa74'
  ],
  MARIGOLD: [
    '#ee9b00',
    '#005f73',
    '#94d2bd',
    '#e9d8a6',
    '#ca6702',
    '#bb3e03',
    '#ae2012',
    '#9b2226',
    '#001219',
    '#0a9396',
    '#f9931e',
    '#03688d',
    '#75a6a1',
    '#e5c480',
    '#ad5006',
    '#982508',
    '#8e121b',
    '#7c131f',
    '#030f15',
    '#066e75'
  ],
  MYSTIC_HUES: [
    '#9663F5',
    '#FF8575',
    '#2E44B9',
    '#6A9BF7',
    '#0FA856',
    '#F57A63',
    '#75FFB8',
    '#B92E7A',
    '#F76A9B',
    '#56A80F',
    '#7f6ae7',
    '#ff8165',
    '#1b44cf',
    '#5c96ff',
    '#21d96d',
    '#f8a05f',
    '#4bd999',
    '#e15d9f',
    '#fb69d2',
    '#6fd525',
    '#bbd635'
  ]
};
